<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="send-reminder-cont">
        <p>This will send a <strong>reminder email</strong> to this customer. Click the button below to send a reminder. </p>
      </div>
      <div class="w-full mt-4">
        <div class="popup-button blue-button" @click="confirm">Send Reminder</div>
        <div class="popup-button black-button" @click="cancel">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    updated: {
      type: Function
    },
    cancel: {
      type: Function
    },
    code: {
      type: String
    }
  },
  name: 'SendReminderPopup',
  mounted () {},
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    handleFocus () {
      // do something here
      console.log('in')
      this.cancel()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    confirm () {
      this.updated(this.code)
    }
  }
}
</script>

<style lang="scss">
.popup-row {
  padding: 10px;
  align-items: center;

  span {
    padding: 0 10px;
  }
}
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.popup-background {
  width: 400px;
  padding: 20px;
  background: white;
  border: 1px solid #555555;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 25%);
}
.popup-button {
  padding: 10px 20px;
  color: white;
  display: inline-block;
  border-radius: 7px;
  cursor:pointer;
  margin-right:15px;
}
</style>
